import img from './img';
import audio from './audio';
import dataConfig from './gameData.config.js';

var config = {
  author: 'MP',
  engine: 'createJS',
  gameConfig: dataConfig,
  title: [
    {
      text: 'Umieść obrazki owoców na ekranie zielonego monitora, zdjęcia dzieci – na ekranie czerwonego monitora, a cienie zwierząt – na ekranie niebieskiego monitora. Stosuj metodę <i>złap, przesuń i upuść.</i>',
      audio: 'games/page016_game1/audio/z16c1.mp3',
    },
  ],
  checkGameSound: {
    positive: 'games/page016_game1/audio/z16c1-brawo.mp3',
    // negative: 'games/page001_game1/audio/z1c1-brawo.mp3',
  },
  checkGameText: {
    positive: 'Ćwiczenie zostało wykonane. Brawo! ',
    negative: '',
  },
  assets: {
    img: img || [],
    audio: audio || [],
    extendetJS: [],
    extendetStyle: [],
  },
};

export default config;
